<template>
    <div>
        <v-dialog
            v-model="display"
            width="350"
            persistent>
            <PrintDialogSkeleton v-if="loading.data"/>
            <v-card flat v-else>
                <v-card-title>{{ $t('print') }}</v-card-title>
                <v-card-text>
                    {{ $t('payment_print_msg') }}
                    <div id="printPaymentReceipt" style="display: none;">
                        <div style="font-size: 18px">
                            <div class="row">
                                <div class="col-sm">  
                                    <div>
                                        <h5 class="text-left mb-0 font-weight-bold">Petra Ready Mixed Concrete</h5>
                                        <p class="mb-4">Accounting Department - Treasury</p>
                                        <p class="text-left mb-0">Industrial Area - Jabra - Block 35</p>
                                        <p class="text-left mb-0">Khartoum - Sudan</p>
                                        <p class="text-left mb-0">Mob: +249912809360 Tel: +249187114000</p>
                                        <p class="text-left">E-mail: petra.concrete@yahoo.com</p>
                                    </div>
                                </div>
                                <div class="col-sm">
                                    <img style="float: right;" class="text-right"  width="200" src="../../assets/petralogo.png" alt="">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col"> 
                                    <h4 style="font-weight: bold;" class="text-left">PAYMENT RECEIPT</h4>
                                </div>
                                <div class="col d-flex justify-content-end">
                                    <div>
                                        <table class="table table-sm" style="border: 2px solid black; font-size: 18px">
                                            <tbody >
                                                <tr style="border: 2px solid black" >
                                                    <th style="border: 2px solid black">Recepit No</th>
                                                    <td>{{payment.code}}</td>
                                                </tr>
                                                <tr style="border: 2px solid black">
                                                    <th style="border: 2px solid black">Recepit Date</th>
                                                    <td>{{payment.created_at}}</td>
                                                </tr>
                                                <tr style="border: 2px solid black">
                                                    <th style="border: 2px solid black">Document Date</th>
                                                    <td>{{payment.date}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-sm">
                                    <table class="table table-sm table-bordered" style="border: 2px solid black; font-size: 18px">
                                        <tbody>
                                            <tr style="border: 2px solid black">
                                                <td class="font-weight-bold" style="border-right: 2px solid black">Received From</td>
                                                <td>{{ payment.customer }}</td>
                                                <td class="font-weight-bold">Customer #</td>
                                                <td>{{ payment.customer_code }}</td>
                                            </tr>
                                            <tr style="border: 2px solid black">
                                                <td class="font-weight-bold" style="border-right: 2px solid black">Payment For</td>
                                                <td colspan="3">{{ payment.description }}</td>
                                            </tr>
                                            <tr style="border: 2px solid black">
                                                <td class="font-weight-bold" style="border-right: 2px solid black">Amount</td>
                                                <td>{{formatCurrency(payment.amount)}}</td>
                                                <td class="font-weight-bold">Exchange Rate</td>
                                                <td>{{ payment.base_amount / payment.amount }}</td>
                                            </tr>
                                            <tr style="border: 2px solid black">
                                                <td class="font-weight-bold" style="border-right: 2px solid black">In Words</td>
                                                <td colspan="3">Only {{ numberToWords(payment.amount) }} {{payment.currency}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col d-flex justify-content-end">
                                    <div>
                                        <table class="table table-sm table-bordered" style="border: 2px solid black; font-size: 18px">
                                            <tbody>
                                                <tr scope="row" style="border: 2px solid black">
                                                    <th class="font-weight-bold" style="border: 2px solid black">Amount</th>
                                                    <td>{{formatCurrency(payment.amount)}}</td>
                                                </tr>
                                                <tr scope="row" style="border: 2px solid black">
                                                    <th style="border: 2px solid black">Payment Mode</th>
                                                    <td>{{payment.payment_mode}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm">
                                    <!-- <h5 class="text-left">{{ $t('title_info') }} :</h5> -->
                                    <table style="border-collapse: collapse; border: none; border: 2px solid black; font-size: 18px" class="table table-bordered table-sm" >
                                        <tbody>
                                            <tr style="border: 2px solid black">
                                                <th style="border: 2px solid black">{{ $t('received_by') }}</th>
                                                <th>{{ $t('received_at') }}</th>
                                            </tr>
                                            <tr style="border: 2px solid black">
                                                <td style="border: 2px solid black">{{ payment.created_by }}</td>
                                                <td>{{ moment(payment.created_at).format("YYYY-MM-DD HH:MM:SS") }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="print" text>
                        {{ $t('print') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import {formatMoney} from 'accounting';
import moment from 'moment';

import converter from 'number-to-words';

export default {
    name: "SalesOrderPrintDialog",
    components: {
        
    },
    data() {
        return {
            display: false,
            openParams: null,
            loading: {
                data: true
            },
            payment: {}
        }
    },
    computed: {
        ...mapState('sales/salesOrder', ["salesOrder"])
    },
    methods: {
        numberToWords(num) {
            return converter.toWords(num);
        },
        moment,
        formatCurrency(amount) {
            return formatMoney(amount, this.payment.currency, 2);
        },
        ...mapActions("sales/salesOrder", ["fetchSalesOrder"]),
        open(payment) {
            this.loading = true;
            this.payment = payment;
            this.loading = false;
            this.display = true;
        },
        close() {
            Object.assign(this.$data, this.$options.data.apply(this));
        },
        print() {
            this.$htmlToPaper("printPaymentReceipt");
            this.close();
        }
       
    },
}
</script>